<div (click)="clicked($event)" class="image-cont">
  <div *ngIf="hasNoImage" class="no-image">No image to show</div>
  <img #image src="{{ imageUrl }}" alt="No image to show" [ngStyle]="{ display: !this.resourceId || this.loading ? 'none' : 'initial' }" />
  <div class="loading-cont" *ngIf="loading"><div class="loading-spinner"></div></div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/image-view/image-view.component.html